var map = {
	"./10-years-10-honest-takes-on-the-industry.md": [
		761,
		4
	],
	"./extreme-programming.md": [
		762,
		5
	],
	"./git-best-practices.md": [
		763,
		6
	],
	"./test-driven-development.md": [
		764,
		7
	],
	"./why-mob-and-pp-rocks.md": [
		765,
		8
	],
	"./why-rust-rocks.md": [
		766,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 758;
module.exports = webpackAsyncContext;